import { createSlice } from '@reduxjs/toolkit'
import { initialState, listReducers } from './listConstants'

const incomingQuotationsSlice = createSlice({
    name: 'ui/incoming-quotations',
    initialState,
    reducers: listReducers
})

export const incomingQuotationsActions = incomingQuotationsSlice.actions
export default incomingQuotationsSlice.reducer
